module.exports = __webpack_public_path__ + "img/jade.be5030ca.webp";